import type { ComparisonConfig } from './ComparisonPage';
import { COMPARISON_ES_P3B } from './seo-comparison-p3b.es';


const SITEMINDER_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-siteminder',
  competitorName: 'SiteMinder',
  heroTitle: 'HotelStack.io vs SiteMinder',
  heroSubtitle: 'SiteMinder es un channel manager australiano fundado en 2006 que se centra en la distribución OTA. HotelStack.io ofrece una plataforma completa de gestión hotelera con 36 módulos incluyendo channel manager integrado, PMS, A&B, herramientas de ingresos y más — todo a un precio más bajo.',
  overviewComparison: [
    { label: 'Tipo de Plataforma', hotelstack: 'HMS Todo-en-Uno (36 Módulos)', competitor: 'Channel Manager + Complementos' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: 'Desde $99+/mes' },
    { label: 'PMS Integrado', hotelstack: 'PMS Completo Incluido', competitor: 'Little Hotelier (Separado)' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'No Disponible' },
    { label: 'Gestión de Ingresos', hotelstack: 'Avanzada (Integrada)', competitor: 'Reglas de Yield Básicas' },
    { label: 'Motor de Reservas', hotelstack: 'BookMyRoom.io (Gratis)', competitor: 'TheBookingButton (Complemento)' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: false },
        { name: 'Gestión de Reservas', hotelstack: true, competitor: 'Vía Little Hotelier' },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: false },
        { name: 'Gestión de Folio del Huésped', hotelstack: true, competitor: false },
        { name: 'Reservas Grupales', hotelstack: true, competitor: false },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Distribución y Gestión de Canales',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: true },
        { name: 'Conectividad GDS', hotelstack: true, competitor: true },
        { name: 'Integración de Metabuscadores', hotelstack: true, competitor: true },
        { name: 'Monitoreo de Paridad de Tarifas', hotelstack: true, competitor: true },
        { name: 'Motor de Reservas Directas', hotelstack: true, competitor: 'Complemento' },
      ],
    },
    {
      category: 'Gestión de Ingresos',
      features: [
        { name: 'Reglas de Precios Dinámicos', hotelstack: true, competitor: 'Básico' },
        { name: 'Simulador de Ingresos Hipotético', hotelstack: true, competitor: false },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: false },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: false },
        { name: 'Analíticas RevPAR', hotelstack: true, competitor: 'Básico' },
      ],
    },
    {
      category: 'Huéspedes y Operaciones',
      features: [
        { name: 'Perfiles de Huésped 360 Grados', hotelstack: true, competitor: false },
        { name: 'Gestión de Limpieza', hotelstack: true, competitor: false },
        { name: 'Terminal POS', hotelstack: true, competitor: false },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: false },
        { name: 'Programación de Personal', hotelstack: true, competitor: false },
        { name: 'Órdenes de Trabajo de Mantenimiento', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-Propiedad y Cumplimiento',
      features: [
        { name: 'Panel de Cadena', hotelstack: true, competitor: 'Limitado' },
        { name: 'Analíticas entre Propiedades', hotelstack: true, competitor: false },
        { name: 'Facturación Multidivisa', hotelstack: true, competitor: 'Limitado' },
        { name: 'Cumplimiento Fiscal Regional', hotelstack: true, competitor: false },
        { name: 'Gestión de Programa de Fidelización', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: false },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: false },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: false },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: false },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$99+',
    hotelstackNote: 'Los 36 módulos incluidos — PMS, channel manager, motor de reservas, A&B, gestión de ingresos. Precios regionales en EUR, GBP, AED, INR, THB. Incorporación y migración gratuitas.',
    competitorNote: 'Channel manager desde $99+/mes. PMS (Little Hotelier) y motor de reservas (TheBookingButton) son productos separados con tarifas separadas. Sin módulos de A&B ni operacionales.',
  },
  advantages: [
    'Plataforma todo-en-uno completa con 36 módulos vs enfoque solo channel manager de SiteMinder',
    'PMS completo integrado — sin necesidad de comprar Little Hotelier por separado para gestión de propiedad',
    'A&B, POS, servicio a habitación y gestión de cocina incluidos sin coste adicional',
    'Gestión avanzada de ingresos con precios dinámicos, previsión y simuladores hipotéticos',
    'CRM de huéspedes con perfiles 360 grados, programas de fidelización y comunicaciones automatizadas',
    'Herramientas operativas: limpieza, mantenimiento y programación de personal totalmente integrados',
    'Precio inicial más bajo ($49 vs $99+) con significativamente más funcionalidad incluida',
    'Incorporación y migración de datos gratuitas con soporte dedicado 24/7',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'SiteMinder destaca como channel manager independiente con fuerte conectividad OTA construida a lo largo de casi dos décadas. Sin embargo, no es una plataforma completa de gestión hotelera. HotelStack.io incluye todo lo que SiteMinder ofrece en distribución más un PMS completo, A&B/POS, gestión de ingresos, CRM de huéspedes y más de 25 módulos adicionales — todo en una suscripción a un precio más bajo.',
    bestFor: [
      'Hoteles que desean una sola plataforma en lugar de ensamblar SiteMinder + PMS + POS',
      'Propiedades que necesitan PMS completo, A&B y herramientas operativas más allá de la gestión de canales',
      'Hoteles que desean gestión avanzada de ingresos y previsión de demanda',
      'Pequeñas propiedades que encuentran SiteMinder demasiado caro solo para distribución',
      'Cadenas multi-propiedad que necesitan gestión centralizada en todas las operaciones',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de SiteMinder a HotelStack.io?', answer: 'Sí. Nuestro equipo de migración transfiere sus conexiones OTA, planes tarifarios y datos de reservas. HotelStack.io se conecta a las mismas 100+ OTAs que soporta SiteMinder. La migración es gratuita y normalmente se completa en 48 horas sin tiempo de inactividad.' },
    { question: '¿HotelStack.io iguala las capacidades de gestión de canales de SiteMinder?', answer: 'Sí. HotelStack.io incluye un channel manager completo conectado a más de 100 OTAs, GDS vía Amadeus y Sabre, y plataformas de metabuscadores. El monitoreo de paridad de tarifas y la sincronización de inventario en tiempo real son funciones estándar incluidas en cada plan.' },
    { question: '¿Por qué elegir HotelStack.io sobre SiteMinder + Little Hotelier?', answer: 'Comprar SiteMinder (channel manager) más Little Hotelier (PMS) más TheBookingButton (motor de reservas) por separado cuesta significativamente más que HotelStack.io y aún carece de A&B, gestión de ingresos, programación de personal y más de 20 módulos adicionales que HotelStack.io incluye.' },
    { question: '¿Es HotelStack.io adecuado para pequeñas propiedades que usan SiteMinder?', answer: 'Por supuesto. Nuestro plan Starter a $49/mes incluye los 36 módulos sin restricciones de funciones. Las pequeñas propiedades obtienen una plataforma de gestión completa en lugar de solo un channel manager, a un coste total más bajo que SiteMinder solo.' },
  ],
};

const ROOMRACCOON_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-roomraccoon',
  competitorName: 'RoomRaccoon',
  heroTitle: 'HotelStack.io vs RoomRaccoon',
  heroSubtitle: 'RoomRaccoon es un HMS holandés impulsado por IA dirigido a hoteles boutique y pequeños. HotelStack.io escala desde boutique hasta empresarial con 36 módulos, gestión avanzada de ingresos, A&B/POS completo y soporte multi-propiedad — todo a precios competitivos.',
  overviewComparison: [
    { label: 'Módulos Totales', hotelstack: '36 Módulos Integrados', competitor: 'Más de 10 Módulos' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: 'Desde $79+/mes' },
    { label: 'Segmento Objetivo', hotelstack: 'PYME a Empresarial', competitor: 'Boutique / Hoteles Pequeños' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'No Disponible' },
    { label: 'Multi-Propiedad', hotelstack: 'Gestión de Cadena Completa', competitor: 'Limitado' },
    { label: 'Alcance Global', hotelstack: 'Más de 40 Países', competitor: 'Principalmente Europa' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Gestión de Reservas', hotelstack: true, competitor: true },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: true },
        { name: 'Gestión de Folio del Huésped', hotelstack: true, competitor: true },
        { name: 'Reservas Grupales', hotelstack: true, competitor: 'Limitado' },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Ingresos y Distribución',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'Menos OTAs' },
        { name: 'Gestión de Yield con IA', hotelstack: true, competitor: true },
        { name: 'Reglas de Precios Dinámicos', hotelstack: true, competitor: 'Básico' },
        { name: 'Simulador de Ingresos Hipotético', hotelstack: true, competitor: false },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: false },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: 'Básico' },
      ],
    },
    {
      category: 'Gestión de Huéspedes',
      features: [
        { name: 'Perfiles de Huésped 360 Grados', hotelstack: true, competitor: 'Básico' },
        { name: 'Gestión de Programa de Fidelización', hotelstack: true, competitor: false },
        { name: 'Automatización de Comunicación con Huéspedes', hotelstack: true, competitor: true },
        { name: 'Analíticas de Gasto del Huésped', hotelstack: true, competitor: false },
        { name: 'Carga y Verificación de ID', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'A&B y Operaciones',
      features: [
        { name: 'Terminal POS', hotelstack: true, competitor: false },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: false },
        { name: 'Sistema de Pantalla de Cocina', hotelstack: true, competitor: false },
        { name: 'Gestión de Limpieza', hotelstack: true, competitor: true },
        { name: 'Órdenes de Trabajo de Mantenimiento', hotelstack: true, competitor: false },
        { name: 'Programación de Personal', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Empresarial y Multi-Propiedad',
      features: [
        { name: 'Panel de Cadena', hotelstack: true, competitor: 'Limitado' },
        { name: 'Analíticas entre Propiedades', hotelstack: true, competitor: false },
        { name: 'Gestión Centralizada de Tarifas', hotelstack: true, competitor: false },
        { name: 'Cumplimiento de Estándares de Marca', hotelstack: true, competitor: false },
        { name: 'Súper-Admin de Plataforma', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: false },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: 'Limitado' },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: false },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: false },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$79+',
    hotelstackNote: 'Los 36 módulos incluidos. Escala desde boutique de 10 habitaciones hasta empresarial de 500+. Precios regionales en EUR, GBP, AED, INR, THB. Incorporación y migración gratuitas.',
    competitorNote: 'Precios escalonados desde EUR 79+/mes. Funciones avanzadas bloqueadas en niveles superiores. Capacidades empresariales y multi-propiedad limitadas.',
  },
  advantages: [
    'Más del triple de módulos (36 vs 10+) sin funciones bloqueadas en niveles premium',
    'Escala desde boutique hasta empresarial — RoomRaccoon está limitado a propiedades pequeñas/medianas',
    'Módulo completo de A&B con POS, servicio a habitación y gestión de cocina incluidos',
    'Gestión completa de cadena multi-propiedad con analíticas centralizadas y distribución de tarifas',
    'Gestión avanzada de ingresos más allá del yield básico con IA — incluye previsión y simuladores',
    'Gestión de programa de fidelización para retención de huéspedes y crecimiento de reservas repetidas',
    'Alcance global en más de 40 países vs enfoque europeo de RoomRaccoon',
    'Gestión de personal con programación, nóminas y seguimiento de rendimiento incluidos',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'RoomRaccoon es una opción sólida para pequeños hoteles boutique europeos que buscan un PMS impulsado por IA con interfaz moderna. Sin embargo, carece de la profundidad, escalabilidad y amplitud operativa que las propiedades en crecimiento necesitan. HotelStack.io ofrece todo lo que RoomRaccoon tiene más A&B/POS, gestión empresarial multi-propiedad, herramientas avanzadas de ingresos y cumplimiento global — siendo la inversión a largo plazo más sólida.',
    bestFor: [
      'Hoteles boutique que desean funciones de nivel empresarial sin precios empresariales',
      'Propiedades que necesitan A&B, POS y gestión de cocina en su HMS',
      'Hoteles que planean escalar de propiedad única a cadenas multi-propiedad',
      'Propiedades fuera de Europa que necesitan cumplimiento y distribución global',
      'Hoteles que desean gestión avanzada de ingresos más allá de la optimización básica de yield',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de RoomRaccoon a HotelStack.io?', answer: 'Sí. Nuestro equipo de migración gestiona la transferencia completa de datos desde RoomRaccoon incluyendo perfiles de huéspedes, historial de reservas, planes tarifarios y configuraciones de habitaciones. La migración es gratuita y normalmente se completa en 48 horas sin tiempo de inactividad.' },
    { question: '¿HotelStack.io tiene funciones impulsadas por IA como RoomRaccoon?', answer: 'Sí. HotelStack.io incluye gestión inteligente de yield, previsión de demanda, reglas de precios dinámicos y simuladores de ingresos. Nuestras herramientas impulsadas por IA van más allá de la optimización básica de yield para incluir monitoreo de competencia y planificación de escenarios hipotéticos.' },
    { question: '¿Es HotelStack.io adecuado para hoteles boutique como RoomRaccoon?', answer: 'Por supuesto. Nuestro plan Starter está diseñado para propiedades de todos los tamaños incluyendo hoteles boutique. Obtiene los 36 módulos desde el primer día sin restricciones de funciones, y la moderna interfaz oscura de lujo proporciona una experiencia elegante que las propiedades boutique aprecian.' },
    { question: '¿Cómo maneja HotelStack.io la gestión multi-propiedad vs RoomRaccoon?', answer: 'HotelStack.io incluye un panel completo de gestión de cadena con analíticas entre propiedades, distribución centralizada de tarifas, estándares de marca e informes consolidados. RoomRaccoon tiene soporte multi-propiedad limitado, lo que hace de HotelStack.io la mejor opción para grupos hoteleros en crecimiento.' },
  ],
};

export const COMPARISON_ES_P3: Record<string, ComparisonConfig> = {
  'hotelstack-vs-siteminder': SITEMINDER_ES,
  'hotelstack-vs-roomraccoon': ROOMRACCOON_ES,
  ...COMPARISON_ES_P3B,
};
